var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "payment-management" }, [
    _c(
      "div",
      { staticClass: "payment-management__header" },
      [
        _c(
          "router-link",
          {
            staticClass: "payment-management__header-back",
            attrs: { to: "/mypage" },
          },
          [_vm._v("＜ " + _vm._s(_vm.$t("paymentManagement.backToMyPage")))]
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "payment-management__content" },
      [
        _c("div", { staticClass: "payment-management__content-title" }, [
          _vm._v(_vm._s(_vm.$t("paymentManagement.title"))),
        ]),
        _c("div", { staticClass: "payment-management__content-box" }, [
          _c(
            "div",
            { staticClass: "payment-management__content-item-header" },
            [
              _c(
                "div",
                { staticClass: "payment-management__content-item-title" },
                [_vm._v(_vm._s(_vm.$t("paymentManagement.account.title")))]
              ),
              !_vm.isFree && !_vm.hasPaymentError && _vm.isCanceled
                ? _c(
                    "div",
                    { staticClass: "payment-management__canceled-badge" },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("paymentManagement.account.canceled")) +
                          " "
                      ),
                    ]
                  )
                : !_vm.isFree &&
                  !_vm.isAppMember &&
                  !_vm.hasPaymentError &&
                  !_vm.isCanceled &&
                  _vm.planCurrentPeriodEnd
                ? _c(
                    "div",
                    { staticClass: "payment-management__content-item-title" },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t("paymentManagement.account.nextRenewalDate")
                          ) +
                          " "
                      ),
                    ]
                  )
                : _vm._e(),
            ]
          ),
          _c(
            "div",
            { staticClass: "payment-management__content-item-body" },
            [
              _c("div", { staticClass: "payment-management__plan-info" }, [
                _vm.isFree
                  ? _c(
                      "div",
                      { staticClass: "payment-management__plan-free" },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t("paymentManagement.account.freeMember")
                            ) +
                            " "
                        ),
                      ]
                    )
                  : _c(
                      "div",
                      {
                        staticClass: "payment-management__plan-premium-wrapper",
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "payment-management__plan-premium" },
                          [
                            _c("img", {
                              staticClass: "payment-management__premium-icon",
                              attrs: {
                                src: require("@/assets/img/icon/premium.png"),
                                alt: _vm.$t(
                                  "paymentManagement.account.premiumAlt"
                                ),
                              },
                            }),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("paymentManagement.account.premium")
                                ) +
                                  "（" +
                                  _vm._s(_vm.billingPlatformName) +
                                  "）"
                              ),
                            ]),
                          ]
                        ),
                        _vm.isAppMember &&
                        !_vm.hasPaymentError &&
                        _vm.isCanceled
                          ? _c(
                              "div",
                              { staticClass: "payment-management__plan-note" },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t(
                                        "paymentManagement.account.appCanceledNote"
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            )
                          : _vm.isAppMember
                          ? _c(
                              "div",
                              { staticClass: "payment-management__plan-note" },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t(
                                        "paymentManagement.account.appNote"
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            )
                          : !_vm.hasPaymentError && _vm.isCanceled
                          ? _c(
                              "div",
                              { staticClass: "payment-management__plan-note" },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.planCanceledEndDate
                                        ? _vm.$t(
                                            "paymentManagement.account.canceledNote",
                                            { date: _vm.planCanceledEndDate }
                                          )
                                        : _vm.$t(
                                            "paymentManagement.account.canceledNoteFallback"
                                          )
                                    ) +
                                    " "
                                ),
                              ]
                            )
                          : _c(
                              "button",
                              {
                                staticClass:
                                  "payment-management__text-link-button",
                                attrs: { type: "button" },
                                on: { click: _vm.onClickModifyPaymentInfo },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t(
                                        "paymentManagement.account.confirmSubscription"
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                      ]
                    ),
              ]),
              _vm.isFree && !_vm.hasPaymentError
                ? [
                    _c(
                      "button",
                      {
                        staticClass: "payment-management__button upgrade",
                        on: { click: _vm.onClickUpgrade },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "payment-management__premium-icon-wrapper",
                          },
                          [
                            _c("img", {
                              staticClass: "payment-management__premium-icon",
                              attrs: {
                                src: require("@/assets/img/icon/premium.png"),
                                alt: _vm.$t(
                                  "paymentManagement.account.premiumAlt"
                                ),
                              },
                            }),
                          ]
                        ),
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.$t("paymentManagement.account.upgrade"))
                          ),
                        ]),
                      ]
                    ),
                  ]
                : !_vm.isAppMember && !_vm.hasPaymentError && !_vm.isCanceled
                ? [
                    _c(
                      "div",
                      { staticClass: "payment-management__plan-schedule" },
                      [
                        _c("div", [_vm._v(_vm._s(_vm.planCurrentPeriodEnd))]),
                        _c(
                          "div",
                          { staticClass: "payment-management__plan-price" },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.planPrice) +
                                _vm._s(
                                  _vm.$t("paymentManagement.account.currency")
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ]),
        _vm.isAppMember && !_vm.hasPaymentError && _vm.isCanceled
          ? _c(
              "div",
              { staticClass: "payment-management__app-recontract-note" },
              [
                _c("IconInfo", {
                  staticClass: "payment-management__app-recontract-note-icon",
                }),
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.$t("paymentManagement.account.appRecontractNote")
                    )
                  ),
                ]),
              ],
              1
            )
          : _vm._e(),
        _c("div", { staticClass: "payment-management__content-box" }, [
          _c(
            "div",
            { staticClass: "payment-management__content-item-header" },
            [
              _c(
                "div",
                { staticClass: "payment-management__content-item-title" },
                [
                  _vm._v(
                    _vm._s(_vm.$t("paymentManagement.paymentMethod.title"))
                  ),
                ]
              ),
            ]
          ),
          _c("div", { staticClass: "payment-management__content-item-body" }, [
            _c(
              "div",
              { staticClass: "payment-management__payment-method" },
              [
                !_vm.billingInfo.cardInfo
                  ? [
                      _c("div", [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "paymentManagement.paymentMethod.notRegistered"
                            )
                          )
                        ),
                      ]),
                    ]
                  : [
                      _c("IconCreditCard", {
                        staticClass: "payment-management__card-number-icon",
                      }),
                      _c(
                        "div",
                        {
                          staticClass:
                            "payment-management__payment-method-card-number",
                        },
                        [_vm._v("**** " + _vm._s(_vm.cardLast4))]
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "payment-management__payment-method-card-expiration-date",
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.cardExpYear) +
                              " / " +
                              _vm._s(_vm.cardExpMonth) +
                              " "
                          ),
                        ]
                      ),
                    ],
                _vm.billingInfo.stripeId
                  ? _c(
                      "button",
                      {
                        staticClass: "payment-management__text-link-button",
                        attrs: { type: "button" },
                        on: { click: _vm.onClickModifyPaymentInfo },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t("paymentManagement.paymentMethod.modify")
                            ) +
                            " "
                        ),
                      ]
                    )
                  : _vm._e(),
              ],
              2
            ),
          ]),
        ]),
        _c("payment-description"),
        !_vm.isFree && !_vm.isAppMember
          ? _c(
              "div",
              { staticClass: "payment-management__bottom-links" },
              [
                !_vm.hasPaymentError && _vm.isCanceled
                  ? _c(
                      "button",
                      {
                        staticClass: "payment-management__text-link-button",
                        attrs: { type: "button" },
                        on: { click: _vm.onClickModifyPaymentInfo },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t(
                                "paymentManagement.account.confirmSubscription"
                              )
                            ) +
                            " "
                        ),
                      ]
                    )
                  : _c(
                      "router-link",
                      {
                        staticClass: "payment-management__unsubscription",
                        attrs: { to: { name: "unsubscriptionAnnounce" } },
                      },
                      [_vm._v(_vm._s(_vm.$t("paymentManagement.unsubscribe")))]
                    ),
              ],
              1
            )
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }